var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HomeworkPreview',{attrs:{"list":_vm.list,"value":_vm.value,"showDownload":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }